import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, defineMessages } from 'react-intl'
import { FacebookShareButton, FacebookIcon } from 'react-share'
import { FacebookProvider, ShareButton } from 'react-facebook'
import { Button } from '../../components'
import { facebookCredentials } from '../../../common/config'


const FacebookShare = ({ url, intl }) => {
  return (
    <div
      className="share-link"
    >
      <FacebookProvider appId={facebookCredentials.clientID}>
        <ShareButton href={url}>
          {intl.formatMessage(messages.share)}
        </ShareButton>
      </FacebookProvider>
      {/*
      <FacebookShareButton
        hashtag="vobo.io"
        url={url}
        quote="Platform for vocabulary learning."
      >
        <FacebookIcon size={32} round />
      </FacebookShareButton>
      */}
    </div>
  )
}

FacebookShare.defaultProps = {
  url: 'https://vobo.io/',
}

FacebookShare.propTypes = {
  url: PropTypes.string,
}

export default injectIntl(FacebookShare)


const messages = defineMessages({
  share: {
    id: 'facebook.share',
    defaultMessage: 'Zdielať na facebooku',
  },
})




// WEBPACK FOOTER //
// ./src/browser/components/social/FacebookShare.js